// HorizontalBarChart.js
import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import data from '../../data/cidr1.json';

const HorizontalBarChart = () => {
    //1_empty_value_distribution


    if (!data || !Array.isArray(data) || data.length === 0) {
        return <div>Loading chart...</div>; // or null
    }
    const option = {
        title: {
            text: 'Percentage of Empty Fields',
            left: 'center',
            textStyle: {
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            formatter: ({ 0: { name, value } }) => `${name}: ${value}%`,
        },
        grid: {
            left: '5%',
            right: '10%',
            bottom: '5%',
            top: '15%',
            containLabel: true,
        },
        xAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value}%',
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
        },
        yAxis: {
            type: 'category',
            data: data?.map(item => item.Column),
            inverse: true,
            axisLabel: {
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            }
        },
        series: [
            {
                name: 'Percentage Empty',
                type: 'bar',
                data: data?.map(item => item.Percentage_Empty),
                itemStyle: {
                    color: '#4f46e5',
                },
                label: {
                    show: true,
                    position: 'right',
                    //formatter: '{c}%',
                    formatter: function (params) {
                        return (params.value).toFixed(2) + '%';
                    },
                    color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',

                },
            },
        ],
    };


    return <div className="border-2 border-gray-300 rounded-lg p-4">
        <ReactECharts option={option} style={{ height: 500, width: '100%' }} />
    </div>;
};

export default HorizontalBarChart;
